import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appShellAuxiliarButtonsHost]'
})
export class AppShellAuxiliarButtonsHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}